import React from "react";
import "./AdvisoryCommittee.css";

const members = [
  { sr: "१", name: "श्री.लक्ष्मणराव शंकरराव कुलकर्णी काका" },
  { sr: "२", name: "श्री.राजाराम जयसिंग विभुते" },
  { sr: "३", name: "श्री.उत्तमराव गणपतराव पाटील" },
  { sr: "४", name: "श्री.कृष्णात शिवराम कुंभार" },
  { sr: "५", name: "श्री.श्रीधर मुकुंद कुलकर्णी" },
  { sr: "६", name: "श्री.प्रवीण जगन्नाथ बुरांडे" },
  { sr: "७", name: "श्री.श्रीधर पांडुरंग सुतार" },
  { sr: "८", name: "श्री.रोहित राजेंद्र विभुते" },
  { sr: "९", name: "श्री.उदय जयसिंग पाटील" },
  { sr: "१०", name: "श्री.दिपक नारायण ढवळे" },
  { sr: "११", name: "श्री.चंद्रकांत बाळकृष्ण शिंदे" },
];

export default function AdvisoryCommittee() {
  return (
    <div className="advisory-container">
      <div className="advisory-card">
        <h2 className="advisory-heading">“सल्लागार समिती”</h2>

        <div className="advisory-table-wrapper">
          <table className="advisory-table">
            <thead>
              <tr>
                <th>अ. क्र.</th>
                <th>नाव</th>
              </tr>
            </thead>
            <tbody>
              {members.map((member) => (
                <tr key={member.sr}>
                  <td>{member.sr}</td>
                  <td>{member.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
